import { REGEX_COLOR_VALIDATION } from '../../../constants';

// add a # in front of color hex if necessary
function hashColorHex(hexValue: string) {
  if (hexValue.charAt(0) !== '#') {
    hexValue = `#${hexValue}`;
  }
  return hexValue;
}

// remove # in front of color hex if necessary
function rawColorHex(hexValue: string) {
  if (hexValue.charAt(0) === '#') {
    hexValue = hexValue.substring(1);
  }

  return hexValue;
}

/**
 * Filters out non-hex characters of the input string and converts the
 * valid hex characters to upper case. Used for managed text input.
 * e.g.
 *      'ABc123'    -> 'ABC123'
 *      'XYZ'       -> ''
 *      'X1Y2Zf'    -> 12F
 *      null        -> ''
 */
function formatHexCode(str?: string | null) {
  if (!str) {
    return '';
  }

  return str.toUpperCase().replace(/[^0-9A-F]/g, '');
}

function safeTrim(value: string) {
  return value == null ? '' : value.trim();
}

function validateColorHex(value: string) {
  const trimmedValue = safeTrim(value);

  return REGEX_COLOR_VALIDATION.test(trimmedValue);
}

export { hashColorHex, rawColorHex, formatHexCode, validateColorHex };
